import React from "react";
import { motion } from "framer-motion";
import { Trophy } from "lucide-react";
import { Section, SectionHeading } from "./_shared";

const Achievements = ({ items = [] }) => (
  <Section id="achievements">
    <SectionHeading
      index="06"
      label="Achievements"
      title="Highlights along the way."
      description="A snapshot of competitive programming milestones and contest performances."
      testId="achievements-heading"
    />
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {items.map((a, i) => (
        <motion.div
          key={a.id || i}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: i * 0.05 }}
          whileHover={{ y: -4 }}
          className="glass glass-hover rounded-2xl p-5 relative overflow-hidden"
          data-testid={`achievement-${i}`}
        >
          <div className="flex items-center justify-between mb-3">
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-cyan-400/20 to-violet-500/20 border border-white/10 grid place-items-center">
              <Trophy size={14} className="text-cyan-300" />
            </div>
            <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-slate-500">{a.platform}</span>
          </div>
          <div className="font-display text-lg font-medium text-white">{a.title}</div>
          <div className="mt-1 text-sm text-slate-400">{a.detail}</div>
        </motion.div>
      ))}
    </div>
  </Section>
);

export default Achievements;
